import { createSlice } from '@reduxjs/toolkit'
import { AlertType } from '../helpers/Constants'

const initialState = {
    // Writes in flight (POST, PUT, DELETE not marked background): they raise
    // the full-screen loader, which stops a second click from sending a bulk
    // send or creating a pipeline twice. A counter instead of a boolean so
    // concurrent requests don't hide it when the first one resolves.
    pendingRequests: 0,
    loading: false,
    // Reads in flight (GETs not marked background): they show the slim bar
    // under the header (components/ReadProgress) and leave the page usable.
    // They used to raise the full-screen loader too, so every page load
    // covered the screen.
    pendingReads: 0,
    readLoading: false,
    alert: {
        open: false,
        message: '',
        type: AlertType.success,
    },
}

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        requestStarted: (state) => {
            state.pendingRequests += 1
            state.loading = true
        },
        requestFinished: (state) => {
            state.pendingRequests = Math.max(0, state.pendingRequests - 1)
            state.loading = state.pendingRequests > 0
        },
        readStarted: (state) => {
            state.pendingReads += 1
            state.readLoading = true
        },
        readFinished: (state) => {
            state.pendingReads = Math.max(0, state.pendingReads - 1)
            state.readLoading = state.pendingReads > 0
        },
        setAlert: (state, action) => {
            state.alert = { ...state.alert, ...action.payload }
        },
    },
})

export const {
    requestStarted,
    requestFinished,
    readStarted,
    readFinished,
    setAlert,
} = appSlice.actions

export default appSlice.reducer
